import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

const PROFILE_ENDPOINTS: Partial<Record<Roles, string>> = {
  [Roles.Trader]: '/v1/topups',
  [Roles.Merchant]: '/v1/merchant/topups',
} as const

const getEndpoint = (): string => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  return userRole ? PROFILE_ENDPOINTS[userRole]! : PROFILE_ENDPOINTS[Roles.Trader]!
}

export const topupsAPI = {
  get baseKey() {
    return getEndpoint()
  },
  list() {
    return this.baseKey
  },
  item(id: string) {
    return `${this.baseKey}/${id}`
  },
  update(id: string) {
    return `${this.baseKey}/${id}`
  },
  // create: `${baseKey}/create`,
  // disable: (id: string) => `${baseKey}/disable/${id}`,
  // enable: (id: string) => `${baseKey}/enable/${id}`,
}
